// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';

export class QuoteSuspendedOrder {
  readonly orderId: string;
  readonly ticketCount: number;
  readonly reasonCode: string | null;
  readonly reasonDescription: string | null;
  readonly lastDeliveredDate: DateTime;

  constructor(data: { [key: string]: any } = {}) {
    this.orderId = data.orderId === undefined ? '' : data.orderId;
    this.ticketCount = data.ticketCount === undefined ? 0 : data.ticketCount;
    this.reasonCode = data.reasonCode === undefined ? null : data.reasonCode;
    this.reasonDescription = data.reasonDescription === undefined ? null : data.reasonDescription;
    this.lastDeliveredDate = DateHelpers.ParseServerDateTime(data.lastDeliveredDate);
  }

  static zero(): QuoteSuspendedOrder {
    const zeroValues: ExcludeMethodsDeep<QuoteSuspendedOrder> = {
      orderId: '',
      ticketCount: 0,
      reasonCode: null,
      reasonDescription: null,
      lastDeliveredDate: DateHelpers.ParseServerDateTime(DateHelpers.ZERO_DATE_STRING),
    };
    return new QuoteSuspendedOrder(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type QuoteSuspendedOrderWireFormat = {
  orderId: string;
  ticketCount: number;
  reasonCode: string | null;
  reasonDescription: string | null;
  lastDeliveredDate: string;
};

type NewQuoteSuspendedOrderProps = PartialDeep<QuoteSuspendedOrder, { recurseIntoArrays: true }>;
export const NewQuoteSuspendedOrder: (props: NewQuoteSuspendedOrderProps) => QuoteSuspendedOrder = (
  props,
) => new QuoteSuspendedOrder(props);

type NewQuoteSuspendedOrderFromWireFormatProps = PartialDeep<
  QuoteSuspendedOrderWireFormat,
  { recurseIntoArrays: true }
>;
export const NewQuoteSuspendedOrderFromWireFormat: (
  props: NewQuoteSuspendedOrderFromWireFormatProps,
) => QuoteSuspendedOrder = (props) => new QuoteSuspendedOrder(props);
